// ~/helpers/sort.js
export function sortByProperty(products, property) {
  const collator = new Intl.Collator('en', {
    numeric: false,
    sensitivity: 'base',
  });

  const sorted = products.sort((a, b) =>
    collator.compare(a[property], b[property])
  );
  return sorted;
}
